import { Dialog, DialogContent, Grid, List } from "@material-ui/core";
import {HTML5Backend} from "react-dnd-html5-backend"
import { DndProvider } from 'react-dnd';
import React, { useEffect, useState } from "react";
import DraggableDashBoardColumn from "./Components/DraggableDashBoardColumn";
import { StylesProvider } from "@material-ui/core/styles";
import "./RearrangeDashBoardColumnModelCss.css"
import { Button } from "@material-ui/core";
import app from "../../../authentication/firebaseStart";
import { useAuthContext } from "../../../authentication/Auth";
import { useTranslation } from "react-i18next";
import { COL_PREFERENCES } from "../../../data/constants";
let selectedItems = [];
let totalItems = [];
let dashboardColumn = {}

const firestore = app.firestore();

const RearrangeDashBoardColumnModel = (props) => {
  const currentPreferences = COL_PREFERENCES[props.preferencePage];

  let listItems = currentPreferences ? [...currentPreferences.DEFAULT_COLUMN_LIST] : [];

  const [check, setCheck] = useState(selectedItems);    // used for check uncheck
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([...totalItems]);    // total list items
  const context = useAuthContext();
  const companyID = context.currentUser.claims.companyID;
  const userId = context.currentUser.uid;
  const { t}  = useTranslation();

  const moveItem = (dragIndex, hoverIndex) => {
    const draggedItem = items[dragIndex];
    const updatedItems = [...items];
    updatedItems.splice(dragIndex, 1);
    updatedItems.splice(hoverIndex, 0, draggedItem);
    setItems(updatedItems);
  };

  const handleClose = () => {
    props.close();
  };

  useEffect(() => {
    setOpen(props.show);
    if(props.show === true){
      if (sessionStorage.getItem("dashboardColumn") !== null) {
        let coloumnData = JSON.parse(sessionStorage.getItem("dashboardColumn"));
        coloumnData = coloumnData[currentPreferences?.DB_NAME]
        selectedItems = [...coloumnData];
      }
      totalItems = [...new Set([...selectedItems, ...listItems])];

    }

    if(props.excludeColumn?.length > 0){
      props.excludeColumn?.forEach((ele)=>{
        let index = totalItems.indexOf(ele);
        if(index>-1){
          totalItems.splice(index,1);
        }
      })

    }
    setCheck(selectedItems);
    setItems(totalItems);

  }, [props]);




  const onClickSave = () => {
    let orderedItemsArray = items.filter((ele) => check.includes(ele));
    dashboardColumn[currentPreferences?.DB_NAME] = orderedItemsArray
    sessionStorage.setItem("dashboardColumn", JSON.stringify(dashboardColumn));
    savePreferenceInDb(orderedItemsArray);
    props.updateColumns(orderedItemsArray);
    handleClose();
  };

  const onClickReset = ()=>{
    dashboardColumn[currentPreferences?.DB_NAME] = currentPreferences?.DEFAULT_SELECTED
    sessionStorage.setItem("dashboardColumn", JSON.stringify(dashboardColumn));
    savePreferenceInDb(currentPreferences?.DEFAULT_SELECTED); 
    props.updateColumns(currentPreferences?.DEFAULT_SELECTED);
    handleClose();
  }

  const savePreferenceInDb = async (orderedItemsArray) => {
    try {
        await firestore
            .collection("tenants")
            .doc(companyID)
            .collection("Users")
            .doc(userId)
            .collection("Preferences")
            .doc(currentPreferences?.DB_NAME)
            .set({
              columnOrder: orderedItemsArray,
            }, { merge: true });
    } catch (err) {
      console.log("Error..........")
      console.log(err);
    }
  };



  return (
    <>
      <StylesProvider injectFirst>
        <Dialog open={!!open? true : false} onClose={handleClose} disableScrollLock={true}>
          <DialogContent>
           <DndProvider backend={HTML5Backend}> 
              <List sx={{ pt: 0 }} key="column-list">
                {items?.map((item, index) => (
                  <DraggableDashBoardColumn
                    key={index}
                    props={item}
                    moveItem={moveItem}
                    index={index}
                    setListItem={setCheck}
                    listItem={check}
                    preferencePage={props.preferencePage}
                  />
                ))}
              </List>
            </DndProvider>
            <Grid container direction="row">
              <Grid item sm={6}>
                <Button
                 data-testid="col-rearrange-reset-btn"
                  variant="contained"
                  color="primary"
                  onClick={onClickReset}
                  style={{
                    width: "93%",
                    marginLeft: "5px",
                    marginBottom: "10px",
                    marginTop: "5px",
                    //marginRight: "10px",
                    backgroundColor: "#D70015",
                  }}
                >
                  {t('workFlow.button.reset')}
                </Button>
              </Grid>
              <Grid item sm={6}>
                <Button
                  data-testid="col-rearrange-apply-btn"
                  variant="contained"
                  color="primary"
                  onClick={onClickSave}
                  style={{
                    width: "93%",
                    marginLeft: "5px",
                    marginBottom: "10px",
                    marginTop: "5px",
                    //marginRight: "10px",
                    backgroundColor: "#0073E6",
                  }}
                >
                  {t('workFlow.button.apply')}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </StylesProvider>
    </>
  );
};
export default RearrangeDashBoardColumnModel;
